<template>
  <div class="bg">
    <div class="background">
      <div class="title">申请评测</div>
      <div class="cha" @click="closeApplyPage"></div>
      <div class="content">
        <div class="inps">
          <p>1.参赛队伍</p>
          <input type="text" id="apply_teams" />
        </div>
        <div class="inps">
          <p>2.队长姓名</p>
          <input type="text" id="apply_name" />
        </div>
        <div class="inps">
          <p>3.队长联系方式</p>
          <input type="text" id="apply_contact" />
        </div>
        <div class="inps">
          <p>5.模型名称</p>
          <input type="text" id="apply_model_name" />
        </div>
        <div class="inps">
          <p>6.参赛单位</p>
          <input type="text" id="apply_unit" />
        </div>
        <div class="inps">
          <p>7.指导老师</p>
          <input type="text" id="apply_teacher" />
        </div>
        <div class="inps">
          <p>8.队伍及模型简介</p>
          <input type="text" id="apply_synopsis" />
        </div>
        <div class="btns">
          <button class="submitApply" @click="submitApply">提交申请</button>
          <button class="myApply" @click="myApply">我的申请</button>
        </div>
      </div>
    </div>

    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">我的申请记录</div>
        <div class="dialog_cha" @click="closeIsShow"></div>

        <div class="content">
          <table>
            <thead>
              <tr>
                <th>时间</th>
                <th>队伍名称</th>
                <th>状态</th>
                <th>结果</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <div v-show="resIsShow">
      <div class="res_black"></div>
      <div class="res_dialog">
        <div class="res_dialog_title">结果上传</div>
        <div class="res_dialog_cha" @click="dialogIsntShow"></div>
        <div class="res_content">
          <form action="post" name="upLoadFile">
            <input type="file" name="file" id="file" />
            <div class="res_fileClickDiv" @click="uploadFile">点击上传文件</div>
            <div class="res_selectFile">
              <div class="res_selectTitle">已选择文件</div>
              <div class="res_fileNmae" v-html="fileNameHtml"></div>
              <input name="submit" type="submit" id="submit" value="提交" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyPage',
  data () {
    return {
      isShow: false,
      resIsShow: false,
      getFilename: '',
      fileDivValue: '',
      fileNameHtml: ''
    }
  },
  methods: {
    submitApply () {
      console.log('点击了提交申请')
    },
    myApply () {
      this.isShow = true
      console.log('点击了我的申请')
    },
    closeIsShow () {
      this.isShow = false
    },
    closeApplyPage () {
      this.$store.commit('applyShowFn', false)
    },
    dialogIsntShow () {
      this.resIsShow = false
    },
    checkResfn () {
      this.resIsShow = true
    },
    uploadFile () {
      const fileDiv = document.querySelector('#file')
      fileDiv.click()
      setInterval(() => {
        if (fileDiv.value !== this.fileDivValue) {
          const index = fileDiv.value.lastIndexOf('\\')
          // console.log(index)
          this.fileDivValue = fileDiv.value.slice(index + 1)
          this.fileNameHtml = this.fileDivValue
          // clearInterval(timmer)
        }
      }, 500)
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTZCHK";
  src: url("/src/assets/font/FZLTCHJW.TTF") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
* {
  padding: 0;
  margin: 0;
}
.bg {
  background: url(/src/assets/img/topBg.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
}
.background {
  width: 90%;
  //   max-width: 600px;
  // background: url(/src/assets/img/previous_box3_bg.png) no-repeat;
  // background-size: 100% 100%;
  background-color: #fff;
  margin: 0 auto;
  border-radius: 0.1rem;
  box-shadow: rgba(149, 157, 165, 0.4) 0px 0.08rem 0.24rem;
  //   margin-top: 0.2rem;
  transform: translateY(0.5rem);
  .title {
    font-size: 1rem;
    color: #141414;
    padding-left: 0.5rem;
    padding-top: 0.5rem;
    font-family: FZLTZCHK;
  }
  .content {
    width: 90%;
    height: 70vh;
    // box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
    margin: 0 auto;
    position: relative;
    .inps {
      height: 2rem;
      p {
        // position: absolute;
        font-family: FZLTZCHK;
        font-size: 0.7rem;
        margin-top: 0.5rem;
        margin-left: 0.2rem;
        // top: 0.2rem;
        // left: 0;
        // font-size: max(20px);
        color: #414141;
        &::before {
          content: "*";
          color: red;
          margin-right: 0.2rem;
        }
      }
      input {
        // padding-top: -0.2rem;
        transform: translateY(-0.2rem);
        height: 1rem;
        width: 80%;
        border-radius: 0.08rem;
        font-family: FZLTZCHK;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
        padding: 0 0.2rem;
        border: 0.01rem solid #e9e9e9;
        margin-left: 1rem;
      }
    }
    .btns {
      .submitApply {
        width: 5rem;
        height: 1.2rem;
        font-family: FZLTZCHK;
        background-color: #fff;
        border-radius: 0.1rem;
        margin-left: 1rem;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
          rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
        border: 0;
        margin-top: 1.5rem;
        cursor: pointer;
      }
      .myApply {
        width: 5rem;
        height: 1.2rem;
        font-family: FZLTZCHK;
        background-color: #9dceff;
        color: #fff;
        border-radius: 0.1rem;
        margin-left: 0.45rem;
        box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
          rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
        border: 0;
        cursor: pointer;
      }
    }
  }
}
.cha {
  position: absolute;
  top: 0.75rem;
  right: 0.55rem;
  height: 0.55rem;
  width: 0.55rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

// 弹框控制
.dialog {
  height: 12rem;
  width: 90%;
  //   max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
    table {
      margin: 0.6rem auto;
      text-align: center;
      font-size: 0.3rem;
      font-family: FZLTZCHK;
      width: 100%;
      border: 0.02rem solid #a2d0ff;
      border-collapse: collapse;
      border-radius: 0.22rem;
      thead tr th,
      tbody tr td {
        padding: 0.1rem;
        border: 0.02rem solid #a2d0ff;
      }
      thead tr th {
        border: 0;
        color: #fff;
        background-color: #9dceff;
      }
      tbody tr td {
        a {
          border-bottom: 1px solid red;
          cursor: pointer;
          color: red;
        }
      }
    }
  }
  .dialog_title {
    font-size: 0.4rem;
    font-family: FZLTZCHK;
    padding-top: 0.5rem;
    padding-left: 0.5rem;
  }
}
.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  height: 0.5rem;
  width: 0.5rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

// 上传结果弹框控制
.res_dialog {
  height: 10rem;
  width: 10rem;
  max-height: 350px;
  max-width: 458px;
  background-color: #fff;
  z-index: 5;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .res_content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
  }
  .res_dialog_title {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }
}
.res_black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}
.res_dialog_cha {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.5rem;
  width: 0.5rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}
#file {
  display: none;
}
.res_fileClickDiv {
  position: absolute;
  text-align: center;
  width: 80%;
  height: 16%;
  // padding-top: 10%;
  line-height: 0.5rem;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-family: FZLTZCHK;
  font-size: 0.21rem;
  color: #fff;
  background-color: #74b9ff;
  border-radius: 0.08rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0 0.08rem 0.24rem;
  border: 0;
  cursor: pointer;
  &::before {
    display: inline-block;
    content: "";
    height: 0.25rem;
    width: 0.25rem;
    background: url(/src/assets/img/upLoadIcon.png) no-repeat;
    background-size: 100% 100%;
    transform: translateY(0.05rem);
    margin-right: 0.1rem;
  }
}

#submit {
  position: absolute;
  right: 0.1rem;
  bottom: 0.1rem;
  color: #fff;
  background-color: #74b9ff;
  border-radius: 0.08rem;
  font-size: 20%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 0.08rem 0.24rem;
  border: 0;
  height: 20%;
  width: 30%;
}

.res_selectFile {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  height: 60%;
  width: 80%;
  background-color: #fff;
  border-radius: 0.08rem;
  box-shadow: rgba(149, 157, 165, 0.4) 0px 0.08rem 0.24rem;
  border: 0;
  .res_selectTitle {
    position: absolute;
    top: 8%;
    left: 8%;
    font-size: 0.15rem;
    color: #454545;
    font-family: FZLTZCHK;
  }
  .res_fileNmae {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 20%;
    font-size: 20%;
    padding: 0 0.1rem;
    line-height: 0.4rem;
    border-radius: 0.08rem;
    font-family: FZLTZCHK;
    overflow: hidden;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
  }
}
.btn_apply {
  position: absolute;
  bottom: -0.2rem;
  right: 3.4rem;
  width: 3rem;
  height: 1rem;
  font-family: FZLTZCHK;
  background-color: #74b9ff;
  color: #fff;
  border-radius: 0.1rem;
  margin-left: 1rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: 0;
  margin-top: 1.5rem;
  cursor: pointer;
}
.btn_new {
  position: absolute;
  bottom: -0.2rem;
  right: -0.2rem;
  width: 3rem;
  height: 1rem;
  font-family: FZLTZCHK;
  background-color: #74b9ff;
  color: #fff;
  border-radius: 0.1rem;
  margin-left: 0.45rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: 0;
  cursor: pointer;
}
</style>
